<ng-container *transloco="let t">
  <main
    class="about-us-component"
    [class.mobile]="(lessThan$ | async)?.sm"
    [class.xs]="(lessThan$ | async)?.xs">
    <div class="wrapper scroll" id="mainAppScroll">
      <div class="content">
        <span
          class="fixed-space-32"
          aria-hidden="true"
          *ngIf="(lessThan$ | async)?.mobileL !== true"></span>
        <article class="content-wrapper popsy-card text-gray-05">
          <span
            class="fixed-space-48"
            aria-hidden="true"
            *ngIf="!(lessThan$ | async)?.sm"></span>
          <div class="head">
            <div class="head-col">
              <h1 class="heading-1">{{ t('about_welcome_title') }}</h1>
              <p class="description">{{ t('about_welcome_text') }}</p>
            </div>
            <span class="fixed-space-24"></span>
            <div class="head-col col-img">
              <img
                class="illustration"
                src="/assets/images/about-phones.webp"
                [alt]="t('about_welcome_title')" />
            </div>
          </div>

          <div class="head reverse">
            <div class="head-col">
              <h1 class="heading-1">{{ t('about_buying_title') }}</h1>
              <p class="description">{{ t('about_buying_text') }}</p>
            </div>
            <span class="fixed-space-48"></span>
            <div class="head-col col-img">
              <img
                class="illustration"
                src="/assets/images/about-illustration.webp"
                [alt]="t('about_buying_title')" />
            </div>
          </div>
          <span class="fixed-space-48"></span>

          <ul class="cards-list">
            <li class="info-card">
              <popsy-icon-warranty-icon class="illustration"></popsy-icon-warranty-icon>
              <span class="fixed-space-8"></span>
              <h3>{{ t('about_warranty_title') }}</h3>
              <span class="fixed-space-8"></span>
              <p class="description">{{ t('about_warranty_text') }}</p>
            </li>
            <span class="fixed-space-16"></span>
            <li class="info-card">
              <popsy-icon-certified-ribbon-1
                class="illustration"></popsy-icon-certified-ribbon-1>
              <span class="fixed-space-8"></span>
              <h3>{{ t('about_inspected_title') }}</h3>
              <span class="fixed-space-8"></span>
              <p class="description">{{ t('about_inspected_text') }}</p>
            </li>
            <span class="fixed-space-16"></span>
            <li class="info-card">
              <popsy-icon-easy-returns class="illustration"></popsy-icon-easy-returns>
              <span class="fixed-space-8"></span>
              <h3>{{ t('about_return_title') }}</h3>
              <span class="fixed-space-8"></span>
              <p class="description">{{ t('about_return_text') }}</p>
            </li>
          </ul>

          <span class="fixed-space-48"></span>
        </article>
        <span class="fixed-space-32" aria-hidden="true"></span>
        <span
          class="fixed-space-64"
          aria-hidden="true"
          *ngIf="(lessThan$ | async)?.sm"></span>
        <ng-container *ngIf="!(inFullScreenMode$ | async)">
          <app-footer
            class="footer"
            [class.phone]="(lessThan$ | async)?.mobileL"></app-footer>
        </ng-container>
      </div>
    </div>
  </main>
</ng-container>
